import { render, staticRenderFns } from "./MoreRestaurantsMealsChart.vue?vue&type=template&id=8e3408b2"
import script from "./MoreRestaurantsMealsChart.vue?vue&type=script&lang=js"
export * from "./MoreRestaurantsMealsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports